import { cn } from '@/lib/utils';
import { personVars } from '@/lib/personColor';
import { de } from '@/i18n/de';
import type { PersonLike } from '@/lib/persons';

export interface PersonChipProps {
  /** `null` renders the dashed "Nicht zugewiesen" chip. */
  person: PersonLike | null;
  /** Overrides the label, e.g. "bei Julia" on the running card. */
  label?: string;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Name on the person's colour, or a dashed chip for unassigned time — the one
 * element that appears in almost every view.
 */
export function PersonChip({ person, label, size = 'md', className }: PersonChipProps) {
  const text = label ?? person?.name ?? de.modal.unassigned;
  const sizeClasses =
    size === 'sm' ? 'px-2 py-0.5 text-chip rounded-badge' : 'px-2.5 py-1 text-chip rounded-chip';

  if (!person) {
    return (
      <span
        className={cn(
          'inline-flex shrink-0 items-center border border-dashed font-semibold',
          'border-free-dash bg-free-surface text-fg-muted',
          sizeClasses,
          className,
        )}
      >
        {text}
      </span>
    );
  }

  return (
    <span
      style={personVars(person.colorIndex)}
      className={cn(
        'person-bg inline-flex shrink-0 items-center border border-transparent font-bold',
        sizeClasses,
        className,
      )}
    >
      {text}
    </span>
  );
}
